const Wishlist = (() => {
  const STORAGE_KEY = 'shopify_wishlist_ids';

  // ─── localStorage: [{id, handle}] ────────────────────────────────
  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function toggleItem(productId, handle) {
    const id = String(productId);
    const items = getItems();
    const idx = items.findIndex(i => String(i.id) === id);
    if (idx === -1) {
      items.push({ id, handle });
    } else {
      items.splice(idx, 1);
      const wishlistGrid = document.getElementById('wishlist-grid');
      if (wishlistGrid) {
        // TODO LOGIC ON THE WISHLIST PAGE
        document.querySelector(`#wishlist-product-grid [data-product-handle="${handle}"]`)?.remove();
        const remaining = document.querySelectorAll('#wishlist-product-grid .grid__item').length;
        updateCount(remaining);
        if (remaining === 0) showEmpty();
        // TODO LOGIC ON THE WISHLIST PAGE
      }
    }
    saveItems(items);
    return idx === -1; // true = добавлен
  }
  function updateCount(n) {
    const el = document.getElementById('wishlist-count');
    if (el) el.textContent = n === 1 ? '1 saved item' : `${n} saved items`;
  }

  function showEmpty() {
    document.getElementById('wishlist-grid').hidden = true;
    document.getElementById('wishlist-empty').hidden = false;
  }

  function isInWishlist(productId) {
    return getItems().some(i => String(i.id) === String(productId));
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('ru-RU', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
      minimumFractionDigits: 0,
    });
  }

  // ─── UI: кнопки на карточках ────────────────────────────────────
  function updateButton(btn) {
    const inList = isInWishlist(btn.dataset.productId);
    const empty  = btn.querySelector('.wishlist-icon--empty');
    const filled = btn.querySelector('.wishlist-icon--filled');

    btn.classList.toggle('is-active', inList);
    if (empty)  empty.style.display  = inList ? 'none' : '';
    if (filled) filled.style.display = inList ? '' : 'none';
    btn.setAttribute('aria-label', inList ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function initButtons() {
    document.querySelectorAll('.button--wishlist').forEach(btn => initButton(btn));
  }
  function initButton(btn) {
    if (btn._wishlistInited) return;
    btn._wishlistInited = true;
    updateButton(btn);

    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation(); // ← останавливает всплытие до <a>
      const { productId, productHandle } = btn.dataset;
      toggleItem(productId, productHandle);

      updateButton(btn);
      updateCounter();

      btn.classList.add('wishlist-btn--bounce');
      setTimeout(() => btn.classList.remove('wishlist-btn--bounce'), 400);
    });
  }

  function updateCounter() {
    const count = getItems().length;
    document.querySelectorAll('.wishlist-count-bubble').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function observeNewButtons() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;

          if (node.classList?.contains('button--wishlist')) {
            initButton(node);
          }

          node.querySelectorAll?.('.button--wishlist').forEach(btn => {
            initButton(btn);
          });
        });
      });
    });

    observer.observe(document.body, {
      childList: true,  
      subtree: true,
    });
  }

  return {
    init() {
      console.log('Initializing wishlist buttons...');
      initButtons();
      updateCounter();
      observeNewButtons();
    },
    reinit: () => {
      console.log('Re-initializing wishlist hooks...');
      initButtons();
      updateCounter();
    },
    initButton,
    getCount: () => getItems().length,
  };
})();

// Make it globally accessible on the window object
window.Wishlist = Wishlist;

document.addEventListener('DOMContentLoaded', () => Wishlist.init());